export const LateFeeConfigurationFragment = gql`
  fragment LateFeeConfigurationFragment on LateFeeConfiguration {
    id
    accrualLimitDateTemplate {
      ...DateTemplateFragment
    }
    feeTemplate {
      ...FeeFragment
    }
  }
`
